<div [ngClass]="styles.cell">
	<vb-profile-picture [profileUrl]="item[insight.insightOptions.fieldDefs.profileImageUri]" [placeholderIconClass]="insight.getIconClass(item)" [altTxt]="item[insight.insightOptions.fieldDefs.display]"></vb-profile-picture>
</div>

<div [ngClass]="styles.descriptionCell">
	<span>{{ item[insight.insightOptions.fieldDefs.display] }}</span>
	<span *ngIf="item[insight.insightOptions.fieldDefs.subDisplay]" [ngClass]="styles.subDisplay">
		{{ item[insight.insightOptions.fieldDefs.subDisplay] }}
	</span>
</div>

<div *ngIf="insight.insightOptions.showEditAccessInput && insight.insightOptions.showEditAccessInput(item)" [ngClass]="styles.cell">
	<button type="button" class="btn badge btn-edit-access bg-secondary" [(ngModel)]="item.canEdit" [hidden]="insight.insightOptions.forceEditAccess" btnCheckbox [btnCheckboxFalse]="false" [btnCheckboxTrue]="true">

		<span [ngClass]="item.canEdit ? 'ok_2' : 'minus'" class="glyphicons"></span>
		{{ 'Media_Videos_Settings_EditAccess' | translate }}
	</button>

	<span class="btn btn-link btn-edit-access badge bg-secondary" [hidden]="!insight.insightOptions.forceEditAccess">
		<span class="glyphicons ok_2"></span>
		{{ 'Media_Videos_Settings_EditAccess' | translate }}
	</span>
</div>

<div>
	<button type="button" class="btn btn-link float-right remove-assigned-item" [attr.aria-label]="'RemoveItemType' | translate : {
			'0': item[insight.insightOptions.fieldDefs.display],
			'1': (item.type | translate)
		}" (click)="insight.removeItem(item)">
		<span class="glyphicons remove_2"></span>
	</button>
</div>
